import { defaultPropertyDefinitions as propertyDefinitions } from "@buildwithflux/constants";
import { getPropertyValueIfNumber, getPropertyValueIfString, getPropertyValueWithUnit } from "../../property/PropertyAPI";
import { capacitorTypeClassifier, connectorTypeClassifier, diodeTypeClassifier, icTypeClassifier, inductorTypeClassifier, logicFunctionClassifier, resistorTypeClassifier, transistorTypeClassifier, } from "./partAttributeClassifiers";
export function getPartSubType(partTypeSpecificValues) {
    if (!partTypeSpecificValues) {
        return undefined;
    }
    if ("resistorType" in partTypeSpecificValues) {
        return partTypeSpecificValues.resistorType;
    }
    if ("capacitorType" in partTypeSpecificValues) {
        return partTypeSpecificValues.capacitorType;
    }
    if ("inductorType" in partTypeSpecificValues) {
        return partTypeSpecificValues.inductorType;
    }
    if ("transistorType" in partTypeSpecificValues) {
        return partTypeSpecificValues.transistorType;
    }
    if ("diodeType" in partTypeSpecificValues) {
        return partTypeSpecificValues.diodeType;
    }
    if ("icType" in partTypeSpecificValues) {
        return partTypeSpecificValues.icType;
    }
    if ("connectorType" in partTypeSpecificValues) {
        return partTypeSpecificValues.connectorType;
    }
    return undefined;
}
export function getPartTypeSpecificValues(normalizedPartType, partVersionData) {
    if (!normalizedPartType) {
        return undefined;
    }
    switch (normalizedPartType) {
        case "Resistors": {
            return {
                resistance: getPropertyValueWithUnit(propertyDefinitions.resistance.label, partVersionData.properties),
                tolerance: getPropertyValueWithUnit(propertyDefinitions.tolerance.label, partVersionData.properties),
                powerRating: getPropertyValueWithUnit(propertyDefinitions.power_rating.label, partVersionData.properties),
                resistorType: resistorTypeClassifier(partVersionData),
            };
        }
        case "Capacitors": {
            return {
                capacitance: getPropertyValueWithUnit(propertyDefinitions.capacitance.label, partVersionData.properties),
                voltageRating: getPropertyValueWithUnit(propertyDefinitions.voltage_rating.label, partVersionData.properties),
                tolerance: getPropertyValueWithUnit(propertyDefinitions.tolerance.label, partVersionData.properties),
                capacitorType: capacitorTypeClassifier(partVersionData),
            };
        }
        case "Inductors": {
            return {
                inductance: getPropertyValueWithUnit(propertyDefinitions.inductance.label, partVersionData.properties),
                currentRating: getPropertyValueWithUnit(propertyDefinitions.current_rating.label, partVersionData.properties),
                tolerance: getPropertyValueWithUnit(propertyDefinitions.tolerance.label, partVersionData.properties),
                inductorShielding: getPropertyValueIfString(propertyDefinitions.inductor_shielding.label, partVersionData.properties),
                inductorType: inductorTypeClassifier(partVersionData),
            };
        }
        case "Transistors": {
            return {
                drainToSourceVoltage: getPropertyValueWithUnit(propertyDefinitions.drain_to_source_voltage.label, partVersionData.properties),
                continuousDrainCurrent: getPropertyValueWithUnit(propertyDefinitions.continuous_drain_current.label, partVersionData.properties),
                transistorType: transistorTypeClassifier(partVersionData),
            };
        }
        case "Rectifiers":
        case "Diodes": {
            return {
                reverseVoltage: getPropertyValueWithUnit(propertyDefinitions.reverse_voltage.label, partVersionData.properties),
                forwardVoltage: getPropertyValueWithUnit(propertyDefinitions.forward_voltage.label, partVersionData.properties),
                diodeType: diodeTypeClassifier(partVersionData),
            };
        }
        case "Integrated Circuits": {
            return {
                operatingVoltage: getPropertyValueWithUnit(propertyDefinitions.operating_voltage.label, partVersionData.properties),
                powerConsumption: getPropertyValueWithUnit(propertyDefinitions.power_requirements.label, partVersionData.properties),
                frequency: getPropertyValueWithUnit(propertyDefinitions.frequency.label, partVersionData.properties),
                logicFunction: getPropertyValueIfString(propertyDefinitions.logic_function.label, partVersionData.properties) ||
                    logicFunctionClassifier(partVersionData),
                icType: icTypeClassifier(partVersionData),
            };
        }
        case "Connectors": {
            return {
                gender: getPropertyValueIfString(propertyDefinitions.connector_gender.label, partVersionData.properties),
                pitch: getPropertyValueWithUnit(propertyDefinitions.connector_pitch.label, partVersionData.properties),
                positions: getPropertyValueIfNumber(propertyDefinitions.connector_positions.label, partVersionData.properties),
                rows: getPropertyValueIfNumber(propertyDefinitions.connector_rows.label, partVersionData.properties),
                connectorType: connectorTypeClassifier(partVersionData),
            };
        }
        default:
            return undefined;
    }
}
//# sourceMappingURL=partTypeSpecificAttributes.js.map